<div [formGroup]="form">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{title}}</h4>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <app-singleselectbox id="selectTestCase" name="Add to the following test case" caption="Add to the following test case"
        [dataSource]="testCases" formControlName="selectedTestCase" [autoSort]="true" displayExpr="Name"
      valueExpr="Id"></app-singleselectbox>

      <label for="selectOutputType">Use the following file as expected output</label>
      <select id="selectOutputType" #outputType class="form-control" formControlName="selectedOutputType">
        <option [value]="null" hidden disabled selected>Please select...</option>
        @for (expectedOutputType of expectedOutputTypes; track expectedOutputType) {
          <option [value]="expectedOutputType.value"
            [title]="getAvailableAdditionalFileTypeStatusDisplayName(expectedOutputType.value)"
          [disabled]="isDisabledOption(expectedOutputType.value)">{{expectedOutputType.displayName}}</option>
        }
      </select>
    </div>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="ok()">Ok</button>
    <button type="button" class="btn btn-link" (click)="cancel()">Cancel</button>
  </div>
</div>
